import { ReferencedProductType } from '~/Api/HrPriceReferencing/MaxPrice';
import { HrMaxPrice, Update, ValidationResult } from '~/Api/User/ProductGroup/HrMaxPrice';

export enum ActionType {
	request = 'HrMaxPrice.request',
	receive = 'HrMaxPrice.receive',
	requestUpdate = 'HrMaxPrice.requestUpdate',
	receiveUpdate = 'HrMaxPrice.receiveUpdate',
	scheduleUpdate = 'HrMaxPrice.scheduleUpdate',
	requestXlsCreate = 'HrMaxPrice.requestXlsCreate',
	receiveXlsCreate = 'HrMaxPrice.receiveXlsCreate',
	requestProductTypes = 'HrMaxPrice.requestProductTypes',
	receiveProductTypes = 'HrMaxPrice.receiveProductTypes',
	prune = 'HrMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	hrMaxPrice: HrMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
	update: Update;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	hrMaxPrice: HrMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestXlsCreate;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveXlsCreate;
	validationResult: ValidationResult | null;
}

export interface RequestProductTypes {
	request: Promise<any>;
	type: ActionType.requestProductTypes;
}

export interface ReceiveProductTypes {
	request: Promise<any>;
	type: ActionType.receiveProductTypes;
	types: ReferencedProductType[] | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| RequestProductTypes
	| ReceiveProductTypes
	| PruneAction;
